import Button from 'components/Button'
import Drawer from 'components/Drawer'
import BlueShareIcon from 'components/icons/BlueShareIcon'
import PreviewContent from 'modules/Roles/NewRoleCreation/Partials/PreviewRoleDrawer/PreviewContent'
import DetailsHeader from 'modules/Roles/ViewRole/Header/JobDetailsDrawer/DetailsHeader'
import React from 'react'

import {
  ContentWrap,
  FlexWrap,
  HeaderWrap,
  MainWrap,
} from 'modules/Roles/ViewRole/Header/JobDetailsDrawer/Style/style'

const JobDetailsDrawer = ({
  detailsDrawer,
  setDetailsDrawer,
  setShareDrawer,
  singleRoleData,
}) => {
  const content = () => {
    return (
      <MainWrap column>
        <HeaderWrap spaceBetween>
          <DetailsHeader
            tittle={singleRoleData?.tittle}
            status={singleRoleData?.status}
            jobyType={singleRoleData?.jobType}
            candidatesCount={`${singleRoleData?.minVacancies} - ${singleRoleData?.maxVacancies}`}
            date={singleRoleData?.endDate}
          />

          <FlexWrap>
            <Button.Secondary
              text="Share Job"
              icon={<BlueShareIcon />}
              onClick={() => {
                setDetailsDrawer(false)
                setShareDrawer(true)
              }}
            />
          </FlexWrap>
        </HeaderWrap>
        <ContentWrap>
          <PreviewContent previewRoleData={singleRoleData} jobSection={true} />
        </ContentWrap>
      </MainWrap>
    )
  }

  return (
    <Drawer
      width="75%"
      title={'Job Details'}
      placement="right"
      visible={detailsDrawer}
      closable
      onClose={() => setDetailsDrawer(false)}
      padding="0 0 20px 0"
      content={content()}
    />
  )
}

export default JobDetailsDrawer
